<template>
  <v-checkbox
    v-bind="$attrs"
    class="themed-checkbox"
    v-on="$listeners"
    @change="$emit('input', $event)"
  >
    <slot />
  </v-checkbox>
</template>

<script>
export default {
  name: "ThemedCheckbox",
  inheritAttrs: false,
};
</script>

<style scoped>
.themed-checkbox {
  color: var(--color-text);
}

.themed-checkbox::v-deep .v-input__slot {
  background-color: transparent !important;
}

.themed-checkbox::v-deep .v-label {
  color: var(--color-text) !important;
  font-weight: 500;
  font-size: 14px;
}

.themed-checkbox::v-deep .v-input__control {
  margin-right: 8px;
}

/* Checkbox styling */
.themed-checkbox::v-deep .v-input--selection-controls__input {
  margin-right: 8px;
}

.themed-checkbox::v-deep .v-input--selection-controls__ripple {
  color: var(--color-text) !important;
}

/* Unchecked state */
.themed-checkbox::v-deep .v-input--selection-controls__input .v-icon {
  color: var(--color-text) !important;
  background-color: var(--color-surface) !important;
  transition: var(--transition-default);
}

/* Hover state */
.themed-checkbox::v-deep .v-input--selection-controls__input:hover .v-icon {
  border-color: var(--color-secondary-light) !important;
  background-color: var(--color-surface-hover) !important;
  color: var(--color-secondary-light) !important;
}

/* Focus state */
.themed-checkbox::v-deep
  .v-input--is-focused
  .v-input--selection-controls__input
  .v-icon {
  border-color: var(--color-secondary) !important;
  box-shadow: 0 0 0 2px var(--color-secondary-light);
}

/* Checked state */
.themed-checkbox::v-deep
  .v-input--selection-controls__input
  .v-input--selection-controls__ripple {
  color: var(--color-secondary) !important;
}

.themed-checkbox::v-deep
  .v-input--selection-controls__input
  .v-input--selection-controls__ripple
  .v-icon {
  color: var(--color-secondary) !important;
  background-color: var(--color-secondary) !important;
  border-color: var(--color-secondary) !important;
}

/* Disabled state */
.themed-checkbox::v-deep .v-input--is-disabled .v-label {
  color: var(--color-text-muted) !important;
  opacity: 0.6;
}

.themed-checkbox::v-deep
  .v-input--is-disabled
  .v-input--selection-controls__input
  .v-icon {
  color: var(--color-text-muted) !important;
  border-color: var(--color-text-muted) !important;
  background-color: var(--color-surface) !important;
  opacity: 0.6;
}

/* Error state */
.themed-checkbox::v-deep .v-input--error .v-label {
  color: var(--color-error) !important;
}

.themed-checkbox::v-deep
  .v-input--error
  .v-input--selection-controls__input
  .v-icon {
  border-color: var(--color-error) !important;
}

.themed-checkbox::v-deep
  .v-input--error
  .v-input--selection-controls__input
  .v-input--selection-controls__ripple
  .v-icon {
  background-color: var(--color-error) !important;
  border-color: var(--color-error) !important;
}

/* Messages styling */
.themed-checkbox::v-deep .v-messages {
  min-height: 16px;
  padding-top: 2px;
  margin-top: -1.5px;
}

.themed-checkbox::v-deep .v-messages__message {
  color: var(--color-error) !important;
  font-size: 12px;
  line-height: 1;
  font-weight: 500;
}

/* Indeterminate state */
.themed-checkbox::v-deep
  .v-input--indeterminate
  .v-input--selection-controls__input
  .v-icon {
  color: var(--color-secondary) !important;
  background-color: var(--color-secondary) !important;
  border-color: var(--color-secondary) !important;
}

/* Animation for checkbox */
.themed-checkbox::v-deep .v-input--selection-controls__input .v-icon {
  animation: checkboxAppear 0.2s ease-out;
}

@keyframes checkboxAppear {
  from {
    opacity: 0.8;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
